module.exports = __webpack_public_path__ + "static/media/cosplay2.7a7ebb32.jpg";